import React, { Component } from "react";
import ISupplierModel from "../../../models/ISupplierModel";
import OwLabel from "../OwLabel/OwLabel";
import SortOrderEnum from "../../../models/SortOrderEnum";
import "./OwSortHeader.scss";

type Props = {
    title: string;
    property?: string; // use this if the title is different than the property, for active chevron check
    currentSortCol: string;
    currentSortOrder: SortOrderEnum;
    sortFn: (sortCol: string, sortOrder: SortOrderEnum) => void;
    isSupplierVendorOverride?: boolean;
    supplierModel?: ISupplierModel;
    /**
     * Additional class names to add to the component
     */
    className?: string;
    /**
     * Additional class names to add to the arrow component
     */
    arrowClassName?: string;
};

type State = {};

class OwSortHeader extends Component<Props, State> {
    static defaultProps = {};

    readonly state: State = {};

    render() {
        let isSortedCol = false;
        let isSortedAsc = false;
        let isSortedDesc = false;

        if (this.props.title === this.props.currentSortCol || this.props.property === this.props.currentSortCol) {
            isSortedCol = true;

            if (this.props.currentSortOrder === "asc") {
                isSortedAsc = true;
                isSortedDesc = false;
            } else {
                isSortedAsc = false;
                isSortedDesc = true;
            }
        }

        return (
            <div className={"d-inline-flex align-items-center OwSortHeader " + this.props.className}>
                <div className={"me-2"}>
                    <OwLabel
                        noBottomMargin={true}
                        title={this.props.title}
                        className={isSortedCol ? "text-warning" : ""}
                        isSupplierVendorOverride={this.props.isSupplierVendorOverride}
                        supplierModel={this.props.supplierModel}
                    />
                </div>
                <div className={"arrows " + this.props.arrowClassName}>
                    <span>
                        <i
                            onClick={(e) => {
                                this.props.sortFn(this.props.title, SortOrderEnum.ASC);
                            }}
                            className={"fas fa-chevron-up pointer " + (isSortedAsc ? "text-primary" : "")}
                        />
                        <br />
                        <i
                            onClick={(e) => {
                                this.props.sortFn(this.props.title, SortOrderEnum.DESC);
                            }}
                            className={"fas fa-chevron-down pointer " + (isSortedDesc ? "text-primary" : "")}
                        />
                    </span>
                </div>
            </div>
        );
    }
}

export default OwSortHeader;
